import { Language } from '@summer-health/types/locale';
import { useTranslation } from 'react-i18next';

export function useLanguage(): Language {
  const { i18n } = useTranslation();
  if (i18n?.language?.startsWith('es')) {
    return Language.Spanish;
  }
  return Language.English;
}
